<template>
  <b-card no-body>
    <b-card-header>
      <div class="d-flex align-items-center card-title-responsive-40">
        <feather-icon
          size="24"
          class="mr-1 d-none d-sm-block"
          :icon="(isChildren !== null ? (isChildren === true ? 'UsersIcon' : 'GlobeIcon') : 'LoaderIcon')"
        />
        <b-card-title class="ml-25">
          {{ $t('navigation.list-' + prefix) }}
        </b-card-title>
      </div>
      <b-button-group class="ml-1">
        <b-button
          v-if="isUserAllowWrite && isChildren !== null && !cid"
          class="btn-icon"
          variant="outline-primary"
          :to="{ name: 'view-projects', query: { isChildren: isChildren }, params: { id: 0 } }"
        >
          <feather-icon
            class="text-nowrap d-block d-sm-none"
            icon="FileIcon"
          />
          <span class="text-nowrap d-none d-sm-block">{{ $t('projects.add-new-' + prefix) }}</span>
        </b-button>
        <b-button
          v-if="!cid"
          class="btn-icon"
          variant="outline-primary"
          @click="expoort()"
        >
          <feather-icon
            class="text-nowrap d-block d-sm-none"
            icon="ExternalLinkIcon"
          />
          <span class="text-nowrap d-none d-sm-block">{{ $t('common.export') }}</span>
        </b-button>
        <b-button
          v-if="!cid"
          id="btn-clean"
          variant="outline-primary"
          class="btn-icon"
          @click="clearFilters()"
        >
          <feather-icon icon="Trash2Icon" />
          <b-tooltip
            triggers="hover"
            target="btn-clean"
            :title=" $t('common.clean-filter')"
            :delay="{ show: 100, hide: 50 }"
          />
        </b-button>
        <b-button
          id="btn-refresh"
          variant="outline-primary"
          class="btn-icon"
          @click="refresh()"
        >
          <feather-icon icon="RefreshCcwIcon" />
          <b-tooltip
            triggers="hover"
            target="btn-refresh"
            :title=" $t('common.refresh')"
            :delay="{ show: 100, hide: 50 }"
          />
        </b-button>
      </b-button-group>
    </b-card-header>

    <b-card-body>
      <projects-list-table
        ref="projectsListTable"
        :is-children="isChildren"
        :cid="cid"
        @on-project-hiden="onProjectHiden"
      />
    </b-card-body>
  </b-card>
</template>

<script>
/* eslint-disable vue/require-prop-types */
import {
  BCard, BCardBody, BCardHeader, BButton, BCardTitle, BButtonGroup, BTooltip,
} from 'bootstrap-vue'
import authService from '@/vue.auth.service'
import ProjectsListTable from '@/views/projects/ProjectsListTable.vue'

export default {
  components: {
    BCard,
    BCardBody,
    BCardHeader,
    BButton,
    BCardTitle,
    BButtonGroup,
    BTooltip,
    ProjectsListTable,
  },
  props: {
    isChildren: {
      type: Boolean,
      default: null,
    },
    cid: {
      required: false,
      default: null,
    },
  },
  data() {
    return {
      isUserAllowWrite: authService.isUserInRole('write'),
    }
  },
  computed: {
    // eslint-disable-next-line no-nested-ternary
    prefix() { return (this.isChildren !== null ? (this.isChildren === true ? 'sad' : 'projects') : 'alls') },
  },
  methods: {
    expoort() {
      this.$refs.projectsListTable.expoort()
    },
    refresh() {
      this.$refs.projectsListTable.refresh()
    },
    clearFilters() {
      this.$refs.projectsListTable.clearFilters()
    },
    onProjectHiden(didX) {
      this.$emit('on-project-hiden', didX)
    },
  },
}
</script>
